import { createContext, useContext } from 'react'

import { ApplicationStore } from './Application.store'
import { ChipsetsStore } from './Chipsets.store'
import { FavoriteSlotListGamesStore } from './FavoriteSlotListGames.store'
import { HttpStore } from './Http.store'
import { ListGamesStore } from './ListGames.store'
import { LoginStore } from './Login.store'
import { NotificationStore } from './Notification.store'
import { RegistrationStore } from './Registration.store'
import { RouletteStore } from './Roulette'
import { GamesStore as RussianPokerGames } from './RussianPoker/Games.store'
import { SentryStore } from './Sentry.store'
import { UIStore } from './UI.store'

export const loginStore = new LoginStore()
export const notificationStore = new NotificationStore()
export const registrationStore = new RegistrationStore()
export const russianPokerGamesStore = new RussianPokerGames()
export const listGamesStore = new ListGamesStore()
export const uiStore = new UIStore()
export const chipsetsStore = new ChipsetsStore()
export const rouletteStore = new RouletteStore()
export const favoriteSlotListGamesStore = new FavoriteSlotListGamesStore()
export const httpStore = new HttpStore(loginStore)
export const applicationStore = new ApplicationStore(loginStore, listGamesStore)
export const sentryStore = new SentryStore()

export const stores = {
  uiStore,
  notificationStore,
  loginStore,
  registrationStore,
  listGamesStore,
  russianPokerGamesStore,
  chipsetsStore,
  rouletteStore,
  favoriteSlotListGamesStore,
  httpStore,
  applicationStore,
  sentryStore,
}

export const AppContext = createContext(stores)

export const useStore = (): typeof stores =>
  useContext(AppContext) as typeof stores

export default stores
